module.exports = function getResource (label, vars = []) {
    const resources = {
        signOutInfoModalTitle: 'Confirmation',
        signOutInfoModalMessage: 'Les articles suivants seront supprimés : Tout le stock immatériel, sauf les cartes-cadeaux. Souhaitez-vous vraiment continuer?',
        signOutInfoModalButtonText: 'Continuer',
        switchCountryErrorTitle: 'Erreur',
        switchCountryErrorMessage: 'Une erreur s’est produite lorsque nous avons essayé de modifier le pays. Veuillez essayer de nouveau.'
    };
    return resources[label];
};
